import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState(['layout', 'w', 'h']),

        horizontal() {
            return this.layout === 'horizontal'
        },

        vertical() {
            return this.portrait
        },

        orientation() {
            return this.horizontal ? 'landscape' : 'portrait'
        },

        portrait() {
            return this.orientation === 'portrait'
        },

        landscape() {
            return this.orientation === 'landscape'
        },

        // This is a truency
        // xsmall() {
        //     return this.w >= 0
        // },

        small() {
            return this.w >= 600
        },

        medium() {
            return this.w >= 1024
        },

        large() {
            return this.w >= 1440
        },

        xlarge() {
            return this.w >= 1920
        }
    }
}
